import { render, staticRenderFns } from "./DAlert.vue?vue&type=template&id=a41308d2&scoped=true&"
import script from "./DAlert.vue?vue&type=script&lang=js&"
export * from "./DAlert.vue?vue&type=script&lang=js&"
import style0 from "./DAlert.vue?vue&type=style&index=0&id=a41308d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41308d2",
  null
  
)

export default component.exports